import { useState, useEffect } from "react";
import { X } from "lucide-react";
import { Link } from "react-router-dom";

const CONSENT_KEY = "shinrai-cookie-consent";

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(CONSENT_KEY);
    if (!stored) {
      const t = setTimeout(() => setShow(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  const respond = (choice) => {
    localStorage.setItem(CONSENT_KEY, JSON.stringify({ choice, at: Date.now() }));
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-0 left-0 right-0 z-50 bg-ink text-pearl/90 shadow-2xl border-t border-pearl/10"
    >
      <div className="max-w-6xl mx-auto px-6 sm:px-10 py-5 flex flex-wrap items-center gap-4 justify-between">
        <p className="text-sm leading-relaxed flex-1 min-w-[240px]">
          Ce site utilise des cookies strictement nécessaires à son fonctionnement et des cookies de mesure d'audience anonymisée.
          {" "}
          <Link to="/politique-cookies" className="underline hover:text-pearl">En savoir plus</Link>.
        </p>
        <div className="flex items-center gap-2">
          <button
            onClick={() => respond("rejected")}
            className="px-4 py-2 text-sm border border-pearl/30 text-pearl hover:bg-pearl/10 transition"
            data-testid="cookie-reject"
          >
            Refuser
          </button>
          <button
            onClick={() => respond("accepted")}
            className="px-4 py-2 text-sm bg-pearl text-ink hover:bg-pearl-dark transition font-medium"
            data-testid="cookie-accept"
          >
            Accepter
          </button>
          <button
            onClick={() => respond("dismissed")}
            className="text-pearl/60 hover:text-pearl transition p-2"
            aria-label="Fermer"
            data-testid="cookie-close"
          >
            <X size={16} />
          </button>
        </div>
      </div>
    </div>
  );
}
